document.addEventListener("DOMContentLoaded", function () {
	const downArrowButtons = document.querySelectorAll(
		".hero__down-arrow-link",
	);

	downArrowButtons.forEach((button) => {
		button.addEventListener("click", function (e) {
      e.preventDefault();
      // alert("down");

      const heroSection = this.closest(".hero");
      const nextSection = heroSection.nextElementSibling;

      if (nextSection) {
        const nextSectionTop =
          nextSection.getBoundingClientRect().top + window.scrollY;
        //const targetY = nextSectionTop - window.innerHeight * 0.25;
        const targetY = nextSectionTop;

        window.scrollTo({
          top: targetY,
          behavior: "smooth",
        });
      }
    });
	});

	const galleryDownArrow = document.querySelector(
		".gallery-hero__down-arrow",
	);

	if (galleryDownArrow) {
		galleryDownArrow.addEventListener("click", (e) => {
			// Get the gallery images section
			const galleryFilters = document.querySelector(".gallery-filters");

			if (galleryFilters) {
				galleryFilters.scrollIntoView({
					behavior: "smooth",
					block: "start",
				});
			}
		});
	}
});
